import { createApp } from "vue";
import App from './App.vue'
import rem from './utils/rem'
import'./assets/fonts/fonts.css'

//导入router路由
import router from './router'
import Header from './components/header.vue'
import mobileHeader from './components/mobileheader.vue'
import backhead from './components/backhead.vue'
import Footer from './components/footer.vue'


const app = createApp(App);
app.component("Header",Header)
app.component("mobileHeader",mobileHeader)
app.component("backhead",backhead)
app.component("Footer",Footer)

//在app上应用路由
app.use(router,rem);
//将app挂载在#app上
app.mount("#app");